import { render, staticRenderFns } from "./PFormSelect.vue?vue&type=template&id=230ced32&scoped=true"
import script from "./PFormSelect.vue?vue&type=script&lang=ts"
export * from "./PFormSelect.vue?vue&type=script&lang=ts"
import style0 from "./PFormSelect.vue?vue&type=style&index=0&id=230ced32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ced32",
  null
  
)

export default component.exports